<template>
  <div class="search-container">
    <form>
      <div class="form-same-line">
        <input
            type="text"
            v-model="search"
            name="map-search"
            @input="openSearchResults"
            :placeholder="placeholder"
        />
        <button type="submit" class="button" @click="doSearch" id="map-search-input"><svg xmlns="http://www.w3.org/2000/svg" height="48" width="48"><path d="m18.75 36-2.15-2.15 9.9-9.9-9.9-9.9 2.15-2.15L30.8 23.95Z"></path></svg></button>
      </div>
    </form>
    <div class="search-results" v-if="search !== '' && !isSearchResultClosed">
      <div
          class="item"
          v-for="result in searchMarkers(search)"
          v-bind:key="result.name"
          @click="() => selectMarker(result)"
      >
        <img :src="result.icon" :alt="result.name"/>
        <span>{{ result.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';


export default {
  name: "SearchField",
  data() {
    let getInput = this.findGetParameter('map-search') || '';
    return {
      search: getInput,
      isSearchResultClosed: true,
    };
  },
  mounted() {
    this.doSearch();
  },
  methods: {
    searchMarkers(search) {
      let results = [];
      const self = this;
      this.markers.forEach((marker) => {
        if (
            self.textContains(search, marker.place) ||
            self.textContains(search, marker.street) ||
            self.textContains(search, marker.name) ||
            self.textContains(search, marker.text) ||
            self.textContains(search, marker.web) ||
            self.textContains(search, marker.email) ||
            self.textContains(search, marker.zip)
        ) {
          results.push(marker);
        }
      });
      return results;
    },
    textContains(word, text) {
      return text.toLowerCase().split(word.toLowerCase()).length > 1;
    },
    selectMarker(marker) {
      this.$emit("clickmarker", marker);
      this.isSearchResultClosed = true;
    },
    openSearchResults() {
      //this.isSearchResultClosed = false;
    },
    findGetParameter(parameterName) {
      var result = null,
          tmp = [];
      location.search
          .substr(1)
          .split("&")
          .forEach(function (item) {
            tmp = item.split("=");
            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
          });
      return result;
    },
    doSearch(e) {
      if(e)
        e.preventDefault();
      axios
          .get('https://nominatim.openstreetmap.org/search?format=jsonv2&q='+this.search)
          .then(response => {
            if (response.data.length > 0) {
              this.$parent.focusLocation( response.data[0] );
            } else {
              console.log('Adress not found');
            }
          })
    }
  },
  props: ["markers", "placeholder"],
};
</script>

<style scoped>
.search-container .search-results {
  background: #fff;
  max-height: 400px;
  overflow-x: hidden;
  box-shadow: 4px 3px 9px #8f8d8d;
  width: calc(500px - 40px);
  position: absolute;
  left: 40px;
  top: 60px;
  z-index: 1000;
}

.search-results .item {
  padding: 10px;
  display: flex;
  color: #20282b;
  align-items: center;
  cursor: pointer;
}

.search-results .item span {
  margin-left: 5px;
}

.search-results .item:hover {
  background-color: #c1c8ce;
}

@media screen and (max-width: 500px) {
  .search-container {
    margin-bottom: 2rem
  }

  .search-container .search-results {
    width: calc(350px - 40px);
  }
}
</style>
